import { useEffect } from 'react'
import { useIntl } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import MainTitle from 'components/common/admin/MainTitle'
import { getSystemConfig, updateSystemConfig } from 'store/admin'
import InitialConfig from 'components/common/config/InitialConfig'
import ConfigTemplate from 'components/common/config/ConfigTemplate'
import SmtpTest from 'components/common/config/SmtpTest'
import "./Conf.scss";

export default function Smtpconf(props: any) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const isAdmin = useSelector((state: any) => state.login.userData.isAdmin, shallowEqual)
  const smtpConfig = useSelector((state: any) => state.admin.smtpConfig)

  // const smtpTestInfo = smtpConfig?.parameter?.mailSmtpTested

  useEffect(() => {
    dispatch(getSystemConfig({ category: "smtp" }))
  }, [])

  return (
    <div className="admin-basic-conf">
      <MainTitle className="small" title="SMTP">
        <InitialConfig category="smtp" />
      </MainTitle>
      <ConfigTemplate category="smtpConfig" updateConfig={updateSystemConfig} order={smtpConfig?.classOrder || []} lists={smtpConfig?.class || {}} isAdmin={isAdmin} />
      <SmtpTest isAdmin={isAdmin} />
    </div>
  );
}